"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const script_1 = __importDefault(require("next/script"));
const Saam = () => {
    return (react_1.default.createElement(script_1.default, { crossOrigin: true, strategy: "lazyOnload", src: "https://prod.cms.col.movistar.es/static/js/sa2m/sa2m.min.js" }));
};
exports.default = Saam;
//# sourceMappingURL=index.js.map